






































import { Vue, Component, Prop } from 'vue-property-decorator'
import { cloneDeep } from 'lodash-es'
import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import ColorPicker from '../ColorPicker.vue'
import feedbackLoopBackground from '../../assets/img/reports/header.png'
import analytics from '@/analytics'

export const DefaultBackgroundImage = feedbackLoopBackground

export enum BackgroundTypeDefault {
  IMAGE = 'IMAGE',
  COLOR = 'COLOR',
}

export interface Window {
  [key:string]: any; // Add index signature
}

export interface BackgroundType {
  IMAGE: string;
  COLOR: string;
}

export interface RGB {
  r: number;
  g: number;
  b: number;
}

export interface Background {
  type: BackgroundType;
  imageURL: string;
  color: RGB;
}

@Component({
  components: {
    Modal,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ColorPicker
  }
})
export default class EditBackgroundModal extends Vue {
  @Prop({ required: true }) value!: Background

  window: Window = window
  originalBackground: Background = {
    type: BackgroundTypeDefault,
    imageURL: '',
    color: {
      r: 0,
      g: 0,
      b: 0
    }
  }

  ignoreNextColorUpdate = true

  created () {
    this.originalBackground = cloneDeep(this.value)
  }

  reset () {
    // Setting the color to null triggers a color update, we dont want to absorb that
    this.ignoreNextColorUpdate = true
    this.$emit('input', {
      type: BackgroundTypeDefault.IMAGE,
      imageURL: DefaultBackgroundImage,
      color: null
    })
  }

  revertAndClose () {
    this.$emit('input', this.originalBackground)
    this.$emit('close')
  }

  apply () {
    this.$emit('close')
    analytics.track('Report Custom Background')
  }

  setColor (rgb: RGB) {
    // Ignore first color update, which happens on load
    if (this.ignoreNextColorUpdate) {
      this.ignoreNextColorUpdate = false
      return
    }
    this.$emit('input', {
      type: BackgroundTypeDefault.COLOR,
      imageURL: null,
      color: rgb
    })
  }

  get canReset (): boolean {
    return !(
      // this.value.type === BackgroundTypeDefault.IMAGE &&
      this.value.imageURL === DefaultBackgroundImage)
  }
}
